import ViewBase from "../../../../framework/core/mvvm/view_base";
import { EmojiCell } from "./emoji_cell";
import BlackJackUtility from "../../../blackjack/Utility/blackJack_utility";
import ChatEmojiSound from "./chat_emoji_sound";

const { ccclass, property } = cc._decorator;

@ccclass
export default class ChatShowEmojiView extends ViewBase {

    @property(cc.Node)
    showPanel: cc.Node = null;

    @property(cc.Node)
    zNode:cc.Node = null;

    @property(cc.Node)
    hNode:cc.Node = null;

    ZEmojiItems:EmojiCell[] = [];

    HEmojiItems:EmojiCell[] = [];

    curTabIndex = 0;
    myPlayerId=0
    sendPlayerId=0

    onLoad() {
        this.ZEmojiItems = this.initEmojiItems(this.zNode);
        this.HEmojiItems = this.initEmojiItems(this.hNode);
    }

    onShow(arg0) 
    {
        super.onShow(arg0)
    }

    clearAnimtionNode(){
        this.showPanel.destroyAllChildren()
    }

    private initEmojiItems(parent:cc.Node):EmojiCell[]{
        let items = [];
        for (let i = 0; i < parent.children.length; i++) {
            let item = parent.children[i];
            items.push(item.getComponent(EmojiCell));
        }
        return items;
    }

    showEmoji(emoji_id:string,sendNode:cc.Node,receiveNode:cc.Node){
        let emojiNode:cc.Node = null;
        if (emoji_id.startsWith('Z') || emoji_id.startsWith('VZ')) {
            emojiNode = this.getEmojiItem(this.ZEmojiItems,emoji_id,this.showPanel)
        }else if (emoji_id.startsWith('H') || emoji_id.startsWith('VH')) {
            emojiNode = this.getEmojiItem(this.HEmojiItems,emoji_id,this.showPanel)
        }

        if (!emojiNode) {
            return;
        }

        let pos = BlackJackUtility.getConvertToNodeSpaceAR(this.showPanel,sendNode)

        let recPos = BlackJackUtility.getConvertToNodeSpaceAR(this.showPanel,receiveNode)
        emojiNode.position=new cc.Vec2(pos.x,pos.y)
        let comp = emojiNode.getComponent(EmojiCell);

        if (emoji_id == 'HF5') {
            ChatEmojiSound.playFly("daodan_bomb")
            this.scheduleOnce(() => {
                emojiNode.position=new cc.Vec2(recPos.x,recPos.y)
                cc.log("火箭j降落"+recPos)
                comp.playArriveEmoji()
            }, 2);
            return;
        }

        if (emoji_id.startsWith('V')) {
            comp.playAnim(recPos);
        }else if (emoji_id.startsWith('Z')) {
            comp.autoDestroy();
        }else if (emoji_id.startsWith('H')) {
            if(emoji_id == 'HF4' && recPos.x>pos.x)
            {
                emojiNode.setScale(-2,2)
            }
            this.playEmojiSound(emojiNode)
            this.scheduleOnce(() => {
                this.moveToAction(emojiNode,recPos,0.7,()=>{
                    comp.playArriveEmoji();
                })  
            }, 0.3);
        }




        // if(emoji_id== 'ZJ2' && recPos.x>pos.x)
        // {
        //     emojiNode.setScale(-2,2)
        // }

        // this.playEmojiSound(emojiNode)
        // let func: Function = this.nodeMoveDone;
        // this.scheduleOnce(() => {
        //     this.moveToAction(emojiNode,recPos,0.7,func)  
        // }, 0.3);
    }



    moveToAction(node:cc.Node,pos:cc.Vec2,time:number,comp?:Function){
        
        let moveTo = cc.moveTo(time,pos);
        let callFunc = cc.callFunc(()=>{if (comp) {
            
            comp(node);
        }})
        node.runAction(cc.sequence(moveTo,callFunc));
    }


    playEmojiSound(emojiNode:cc.Node) {
        let item=emojiNode.getComponent(EmojiCell)
        if(item.emoji_id =="HF4"|| item.emoji_id =="HF2")
        {
            item.isHasPlay=true;
            let soundNmae=item.getSound(emojiNode.name)
            
            ChatEmojiSound.playBomb(soundNmae)
        }
        
    }
   
    private getEmojiItem(items:EmojiCell[],emoji_id:string,parent:cc.Node):cc.Node{
        for (let i = 0; i < items.length; i++) {
            let item = items[i];
            if (item.emoji_id == emoji_id) {
                let node = cc.instantiate(item.node);
                node.position = cc.Vec2.ZERO;
                node.scale = 1.5;
                node.parent = parent;
                node.active = true;
                return node;
            }
        }
    }
    
   
}